// src/helpers/insuranceSwap.js
// Exact "CMS-MEDICARE" payor only (same rule as the API's swapOrderInsurance); other Medicare plans don't qualify.
export function isCmsMedicarePayor(payor) {
  return String(payor || "").replace(/\s+/g, "").toUpperCase() === "CMS-MEDICARE";
}

export function getOrderInsurance(order) {
  const insurance = order?.billing_info?.insurance || {};
  return {
    primaryPayor: insurance.primary_insurance?.payor || "",
    secondaryPayor: insurance.secondary_insurance?.payor || "",
  };
}

// "swap" when CMS Medicare can be moved to primary, "undo" when a manual swap can be reverted, otherwise null.
export function getInsuranceSwapAction(order) {
  if (!order || order.billing_type !== "INSURANCE") return null;
  const { primaryPayor, secondaryPayor } = getOrderInsurance(order);
  if (!primaryPayor || !secondaryPayor) return null;
  if (order.insurance_swapped_manually) return "undo";
  return isCmsMedicarePayor(secondaryPayor) ? "swap" : null;
}

